<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a
            class="linkstyle"
            href="https://www.chanchao.com.tw/ExhibitorServiceTW/"
            >展覽列表</a
          ><span>/</span>
          <em name="Exhibition">{{ ExhibitionName }}</em>
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="homeLeft">
        <div class="MbDevice">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
        </div>

        <div class="expoLogo">
          <div class="imgCorp squareThumbHome">
            <img :src="ExhLogo" width="100%" />
          </div>
        </div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition">{{ ExhibitionName }}</p>
          <p>{{ Exhdate }}</p>
          <p>{{ ExhVenue }}</p>
        </div>
        <p class="clear"></p>
      </div>
      <div class="homeRight">
        <h1>{{ Directory_ComName }}</h1>
        <p class="my-3">&nbsp;</p>
        <ul id="progress">
          <li class="progressEdit">
            <div class="progressLeft">
              <div class="profile">
                <h3>
                  <!-- 公司資訊 -->
                  <span name="homeCompanyInfo"></span>
                  <!-- <span class="icon incomplete ml-1"></span> -->
                </h3>
                <p>請上傳公司 LOGO，並填寫展出品牌填寫資訊</p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/profile?no=${RegNo}`"
                    class="btnStyle"
                  >
                    編輯</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>

          <li
            class="progressStyle"
            style="padding-left: 0px"
            v-if="!LocalExh && hasShowPreview"
          >
            <div class="progressIcon">
              <i class="far fa-address-card IconStyle"></i>
            </div>
            <div class="progressLeft">
              <div>
                <h3>展前快訊登錄</h3>
                <p>
                  請在<span class="red"> {{ ClosedateString }} </span
                  >前完成展前快訊登錄
                </p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${GeteventId}&no=${RegNo}`"
                    class="btnStyle"
                    >編輯</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>

          <li class="progressStyle" style="padding-left: 0px" v-if="!LocalExh">
            <div class="progressIcon">
              <i class="far fa-address-card IconStyle"></i>
            </div>
            <div class="progressLeft">
              <div>
                <h3>參展證</h3>
                <p>
                  請在
                  <span class="red">{{ ES_Badge_Deadline }}</span>
                  前完成參展證申請
                </p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/Badge?no=${RegNo}`"
                    class="btnStyle"
                    >編輯</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>

          <li class="progressFascia" style="padding-left: 0px" v-if="!LocalExh">
            <div class="progressIcon">
              <i class="fas fa-sign IconStyle"></i>
            </div>
            <div class="progressLeft">
              <div>
                <h3>招牌登錄</h3>
                <p>
                  請在
                  <span class="red">{{ ES_Fascia_Deadline }}</span>
                  前完成登錄
                </p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/Fascia?no=${RegNo}`"
                    class="btnStyle"
                    >編輯</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
          <li class="progressBook">
            <div class="progressLeft">
              <div class="directory">
                <h3>
                  <span name="homeDirectoryTitle"></span>
                  <!-- <span class="icon incomplete ml-1"></span> -->
                </h3>
                <p class="HasDirectory">
                  請於
                  <span class="red">{{ DirectoryDeadline }}</span>
                  前登錄本年度的大會專刊資訊
                </p>
                <p class="NoDirectory">
                  請上傳公司名稱、網址、廠商/產品介紹，將露出於官網->參展商列表
                </p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/directory?no=${RegNo}`"
                    class="btnStyle"
                    >編輯</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>

          <li class="progressProd">
            <div class="progressLeft">
              <div>
                <h3>參展產品</h3>
                <p>
                  請建立產品資訊，您已經建立
                  <span class="red">{{ ProductStatus }}</span>
                  個產品，還可以建立
                  <span class="red">{{ remainingProducts }} </span>
                  個產品
                </p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${RegNo}`"
                    class="btnStyle"
                    >編輯</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>

          <li
            class="progressStyle"
            style="padding-left: 0px"
            v-if="LocalExh && !Exh_FoodTaichung"
          >
            <div class="progressIcon ml-md-1 ml-0">
              <img
                src="../../assets/images/food-stand.png"
                width="45px"
                alt=""
              />
            </div>
            <div class="progressLeft">
              <div>
                <h3>攤位活動</h3>
                <p>
                  可發佈攤位活動，您已經發佈
                  <span class="red">{{ BoothEventStatus }}</span>
                  個攤位活動，還可以發佈
                  <span class="red">{{ remainingBoothEvents }}</span>
                  個攤位活動
                </p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${RegNo}`"
                    class="btnStyle"
                    >編輯</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>

          <li class="progressNews">
            <div class="progressLeft">
              <div>
                <h3>新聞稿</h3>
                <p>
                  請發佈新聞稿，您已經發佈
                  <span class="red">{{ PressReleaseStatus }}</span>
                  個新聞稿，還可以發佈
                  <span class="red">{{ remainingNews }}</span>
                  個新聞稿
                </p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p>
                  <a
                    :href="`https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${RegNo}`"
                    class="btnStyle"
                    >編輯</a
                  >
                </p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
          <li class="progressInvit">
            <div class="progressLeft">
              <div>
                <h3>客戶邀請</h3>
                <p>歡迎使用電子邀請函、代理申請、VIP申請邀請重要客戶</p>
              </div>
            </div>
            <div class="progressRight">
              <div>
                <p><a href="" class="btnStyle getInvUrl">邀請</a></p>
              </div>
            </div>
            <p class="clear"></p>
          </li>
        </ul>
      </div>
      <p class="clear"></p>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      ExhVenue: "",
      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      eExhVenue: "",

      Exhdate: "",
      DirectoryDeadline: "",
      DirectoryArchived: "",
      RegNo: "",
      ExhibitionName: "",
      Directory_ComName: "",
      UserId: "",
      existProNum: "",
      leftProNum: "",
      existNewsNum: "",
      leftNewsNum: "",

      leftboothNum: "",
      ProductAmount: "",
      newsAmount: "",
      bootheventAmount: "",

      ES_Badge_Deadline: "",
      ES_Fascia_Deadline: "",

      LocalExh: true,
      BoothEventStatus: "",
      PressReleaseStatus: "",
      ProductStatus: "",

      CloseSec: "",
      CloseMin: "",
      ClosedateString: "",
      GeteventId: "",
      hasShowPreview: false,
      BoothEventAvaliable: "",
      ProductAvaliable: "",
      NewsAvaliable: "",
      quotaLoaded: false,
      exhibitorStatusLoaded: false,
      Exh_FoodTaichung: false,
    };
  },

  metaInfo() {
    return {
      title: "首頁 - 展昭參展商管理系統",
    };
  },

  methods: {},

  computed: {
    remainingProducts() {
      if (!this.quotaLoaded || !this.exhibitorStatusLoaded) return "-";
      const remaining =
        Number(this.ProductAvaliable || 0) - Number(this.ProductStatus || 0);
      return remaining > 0 ? remaining : 0;
    },
    remainingBoothEvents() {
      if (!this.quotaLoaded || !this.exhibitorStatusLoaded) return "-";
      const remaining =
        Number(this.BoothEventAvaliable || 0) -
        Number(this.BoothEventStatus || 0);
      return remaining > 0 ? remaining : 0;
    },
    remainingNews() {
      if (!this.quotaLoaded || !this.exhibitorStatusLoaded) return "-";
      const remaining =
        Number(this.NewsAvaliable || 0) - Number(this.PressReleaseStatus || 0);
      return remaining > 0 ? remaining : 0;
    },
  },
  created() {
    const vm = this;

    const query = new URLSearchParams(window.location.search);
    vm.RegNo = query.get("no") || location.href.split("no=")[1] || "";
    vm.RegNo = vm.RegNo.split("&")[0];

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/VIP/Info/${vm.RegNo}`)
      .then((response) => {
        const data = response.data && response.data.Data ? response.data.Data : {};

        vm.BoothEventAvaliable = Number(data.BoothEventAmount || 0);
        vm.ProductAvaliable = Number(data.ProductAmount || 0);
        vm.NewsAvaliable = Number(data.NewsAmount || 0);
        vm.quotaLoaded = true;
      })
      .catch((error) => {
        console.error("VIP quota API error:", error);
      });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=tw`,
      )
      .then((response) => {
        if (response.data.Code == 200) {
          vm.ExhibitionName = response.data.Data.Exhibition;
          vm.ExhVenue = response.data.Data.ExhVenue;
          vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
          vm.Exhdate =
            response.data.Data.ExhBegin + " - " + response.data.Data.ExhEnd;
          vm.DirectoryDeadline = response.data.Data.DirectoryDeadline;
          vm.ES_Fascia_Deadline = response.data.Data.ES_Fascia_Deadline;
          vm.ES_Badge_Deadline = response.data.Data.ES_Badge_Deadline;

          vm.ExhBegin = response.data.Data.ExhBegin;
          vm.ExhEnd = response.data.Data.ExhEnd;
          vm.eExhVenue = response.data.Data.eExhVenue;

          let ExpoLocation = response.data.Data.ExpoLocation;

          let ExhibitionCode = response.data.Data.Original_Code;

          if (ExhibitionCode == "TCFB") {
            vm.Exh_FoodTaichung = true;
          } else {
            vm.Exh_FoodTaichung = false;
          }

          if (ExpoLocation === "T" || ExpoLocation === null) {
            vm.LocalExh = true;
          } else {
            vm.LocalExh = false;
          }

          if (response.data.Data.DirectoryArchived == 0) {
            $(".progressBook").addClass("hideDirectory");
          } else {
            $(".progressBook").removeClass("hideDirectory");
          }

          vm.$nextTick(() => {
            if (response.data.Data.DirectoryHardcopy == 1) {
              $('[name="directoryTitle"]').text("會刊登錄");
              $('[name="directoryTitleEn"]').text("Directory Entry");
              $('[name="profileTitleEn"]').text("Basic Information");
              $('[name="homeCompanyInfo"]').text("基本資料");
              $('[name="homeDirectoryTitle"]').text("會刊登錄");
              $('[name="homeDirectoryTitleEn"]').text("Directory Entry");
              $(".HasDirectory").addClass("show");
              $(".NoDirectory").addClass("hide");
            } else {
              $('[name="directoryTitle"]').text("廠商介紹");
              $('[name="directoryTitleEn"]').text("Exhibitor Profile");
              $('[name="profileTitleEn"]').text("Basic Information");
              $('[name="homeCompanyInfo"]').text("基本資料");
              $('[name="homeDirectoryTitle"]').text("廠商介紹");
              $('[name="homeDirectoryTitleEn"]').text("Exhibitor Profile");
              $(".HasDirectory").addClass("hide");
              $(".NoDirectory").addClass("show");
            }
          });

          axios
            .get(
              `https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`,
            )
            .then((response) => {
              // console.log(response.data.Code)

              if (response.data.Code == 200) {
                vm.Directory_ComName = response.data.Data.Directory_ComName;
                vm.BoothEventStatus = Number(response.data.Data.BoothEventStatus || 0); //目前參展商新增多少攤位活動
                vm.PressReleaseStatus = Number(
                  response.data.Data.PressReleaseStatus || 0,
                );
                vm.ProductStatus = Number(response.data.Data.ProductStatus || 0);
                vm.exhibitorStatusLoaded = true;

                if (
                  response.data.Data.Logo &&
                  response.data.Data.Logo !== "default.jpg" &&
                  response.data.Data.BrandName
                ) {
                  $("div.profile h3 .icon").addClass("complete");
                }
              } else if (response.data.Code == 404) {
                vm.BoothEventStatus = 0;
                vm.PressReleaseStatus = 0;
                vm.ProductStatus = 0;
                vm.exhibitorStatusLoaded = true;
              } else {
                alert("系統忙線中，請稍後再試");
              }
            });
        } else if (response.data.Code == 404) {
          // console.log('查無資料')
        } else {
          alert("系統忙線中，請稍後再試");
        }
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Directory/${vm.RegNo}`)
      .then((response) => {
        if (response.data.Data.Product) {
          $("div.directory h3 .icon").addClass("complete");
        }
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=tw`,
      )
      .then((response) => {
        if (response.data.Code == 200) {
          $(".progressInvit").removeClass("hideInvit");

          for (var i = 0; i < response.data.Data.length; i++) {
            if (
              response.data.Data[i].Url == "inviteReg" ||
              response.data.Data[i].Url == "invite"
            ) {
              // let GetUrl = response.data.Data[i].Url
              // let UrlDelHtml = GetUrl.split('.')[0]
              $("a.getInvUrl").attr(
                "href",
                response.data.Data[i].Url + "?no=" + vm.RegNo,
              );
            }
          }
        } else {
          $(".progressInvit").addClass("hideInvit");
        }
      });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MenuOthers/${vm.RegNo}?lang=en`,
      )
      .then((response) => {
        if (response.data.Code === 200 && response.data.Data.length > 0) {
          const menu = response.data.Data.find(
            (item) => item.MenuName === "Show Preview Entry",
          );

          if (menu) {
            // 從 Url 中擷取 eventId
            let urlParams = new URL(menu.Url).searchParams;
            vm.GeteventId = urlParams.get("eventId");
            vm.hasShowPreview = true;

            return axios.get(
              `https://www.chanchao.com.tw/apiExhibitors/MarketingEvent?eventId=${vm.GeteventId}`,
            );
          } else {
            vm.hasShowPreview = false;
          }
        } else {
          vm.hasShowPreview = false;
        }
      })
      .then((res2) => {
        if (res2 && res2.data.Code === 200) {
          let EventClostDate = res2.data.Data.backEndEndDate;

          let Closedate = new Date(Number(EventClostDate));

          // 判斷是不是 00:00:00
          if (
            Closedate.getHours() === 0 &&
            Closedate.getMinutes() === 0 &&
            Closedate.getSeconds() === 0
          ) {
            Closedate.setDate(Closedate.getDate() - 1);
          }

          vm.ClosedateString =
            Closedate.getFullYear() +
            "/" +
            (Closedate.getMonth() + 1) +
            "/" +
            Closedate.getDate();
        }
      })
      .catch((err) => {
        console.error("API 錯誤:", err);
        vm.hasShowPreview = false;
      });
  },
};
</script>

<style lang="scss">
a:hover {
  color: #ffffff;
}

.linkstyle:hover {
  color: #0056b3;
}

.hide {
  display: none;
}

.show {
  display: block;
}

#progress li.progressEdit {
  background-image: url("../../assets/images/progressEdit.svg");
}

#progress li.progressBook {
  background-image: url("../../assets/images/progressBook.svg");
}

#progress li.progressProd {
  background-image: url("../../assets/images/progressProd.svg");
}

#progress li.progressNews {
  background-image: url("../../assets/images/progressNews.svg");
}

#progress li.progressInvit {
  background-image: url("../../assets/images/progressInvit.svg");
}

#progress li h3 span.incomplete {
  width: 18px;
  height: 18px;
  display: inline-block;
  background-image: url("../../assets/images/tickGray.svg");
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

#progress li h3 span.complete {
  background-image: url("../../assets/images/tick.svg");
}

.hideDirectory {
  display: none;
}

.hideInvit {
  display: none;
}

#progress li .progressIcon {
  width: 50px;
  text-align: center;
  color: #a7aeb5c9;
  margin-right: 20px;
}

@media screen and (max-width: 800px) {
  .IconStyle {
    color: #a7aeb5d6;
    font-size: 35px;
  }
}

@media screen and (min-width: 801px) {
  .IconStyle {
    color: #a7aeb5d6;
    font-size: 46px;
  }
}
.progressFascia {
  display: flex;
  align-items: center;
}

.progressStyle {
  display: flex;
  align-items: center;
}
</style>
